<template>
    <div class="registration-service">
      <div class="header-info">
        <div class="title-container">
          <h2><i class="el-icon-first-aid-kit"></i> 门诊挂号服务</h2>
        </div>
        <div class="operator-info">
          <span>操作员: 张晓红</span>
          <span>工号: 10086</span>
          <span>当前时间: {{currentTime}}</span>
          <el-tag type="success">在线</el-tag>
        </div>
      </div>
      
      <el-row :gutter="20">
        <!-- 左侧患者信息 -->
        <el-col :span="8">
          <el-card shadow="hover" class="patient-card">
            <div slot="header">
              <div class="card-header">
                <span><i class="el-icon-user"></i> 患者信息</span>
                <el-button type="text" icon="el-icon-plus" @click="newPatient">新患者</el-button>
              </div>
            </div>
            
            <div class="search-area">
              <el-input placeholder="输入姓名/身份证/手机号查询" v-model="searchKey" class="search-input">
                <el-button slot="append" icon="el-icon-search" @click="searchPatient"></el-button>
              </el-input>
            </div>
            
            <el-form :model="patientForm" ref="patientForm" label-width="85px" :rules="patientRules" class="patient-form">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="patientForm.name" placeholder="请输入姓名"></el-input>
              </el-form-item>
              
              <el-form-item label="身份证" prop="idCard">
                <el-input v-model="patientForm.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
              
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="patientForm.phone" placeholder="请输入手机号"></el-input>
              </el-form-item>
              
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="性别">
                    <el-select v-model="patientForm.gender" placeholder="请选择" style="width: 100%">
                      <el-option label="男" value="男"></el-option>
                      <el-option label="女" value="女"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="年龄">
                    <el-input-number v-model="patientForm.age" :min="0" :max="120" size="small" style="width: 100%"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-form-item label="就诊卡号">
                <el-input v-model="patientForm.cardNo" placeholder="自动生成或输入">
                  <el-button slot="append" icon="el-icon-magic-stick" @click="generateCardNo">生成</el-button>
                </el-input>
              </el-form-item>
              
              <el-form-item label="医保类型">
                <el-select v-model="patientForm.insuranceType" placeholder="请选择" style="width: 100%">
                  <el-option label="自费" value="self"></el-option>
                  <el-option label="城镇职工医保" value="employee"></el-option>
                  <el-option label="城乡居民医保" value="resident"></el-option>
                  <el-option label="新农合" value="rural"></el-option>
                  <el-option label="商业保险" value="commercial"></el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item label="备注">
                <el-input type="textarea" v-model="patientForm.remark" placeholder="特殊情况请备注" :rows="2"></el-input>
              </el-form-item>
              
              <div class="form-actions">
                <el-button type="primary" @click="confirmPatient" icon="el-icon-check">确认信息</el-button>
                <el-button @click="resetPatientForm" icon="el-icon-refresh">重置</el-button>
              </div>
            </el-form>
          </el-card>
        </el-col>
        
        <!-- 右侧挂号操作 -->
        <el-col :span="16">
          <el-card shadow="hover" class="registration-card">
            <div slot="header">
              <div class="card-header">
                <span><i class="el-icon-date"></i> 挂号信息</span>
                <div>
                  <el-tag v-if="patientConfirmed" type="success">患者已确认</el-tag>
                  <el-tag v-else type="info">未确认患者</el-tag>
                </div>
              </div>
            </div>
            
            <div class="registration-area" :class="{'disabled': !patientConfirmed}">
              <el-form :model="registrationForm" ref="registrationForm" label-width="100px" :rules="registrationRules">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="挂号日期" prop="registerDate">
                      <el-date-picker 
                        v-model="registrationForm.registerDate" 
                        type="date" 
                        placeholder="选择日期" 
                        style="width: 100%"
                        :picker-options="datePickerOptions"
                        @change="handleDateChange">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="就诊类型" prop="visitType">
                      <el-select v-model="registrationForm.visitType" placeholder="请选择" style="width: 100%">
                        <el-option label="普通门诊" value="normal"></el-option>
                        <el-option label="专家门诊" value="expert"></el-option>
                        <el-option label="特需门诊" value="special"></el-option>
                        <el-option label="急诊" value="emergency"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="科室" prop="department">
                      <el-cascader
                        v-model="registrationForm.department"
                        :options="departmentOptions"
                        placeholder="请选择科室"
                        style="width: 100%"
                        @change="handleDepartmentChange">
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="医生" prop="doctor">
                      <el-select v-model="registrationForm.doctor" placeholder="请选择医生" style="width: 100%" @change="handleDoctorChange">
                        <el-option
                          v-for="doctor in availableDoctors"
                          :key="doctor.id"
                          :label="doctor.name + ' (' + doctor.title + ')'"
                          :value="doctor.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row>
                  <el-col :span="24">
                    <div class="schedule-title">
                      <h4>可预约时段</h4>
                      <el-tag>剩余号 {{ availableTimeSlots.length }} 个</el-tag>
                    </div>
                    <div class="time-slots">
                      <el-radio-group v-model="registrationForm.timeSlot" size="small">
                        <el-radio-button 
                          v-for="(slot, index) in availableTimeSlots" 
                          :key="index" 
                          :label="slot.id"
                          :disabled="slot.remaining <= 0">
                          {{ slot.time }} (余 {{ slot.remaining }})
                        </el-radio-button>
                      </el-radio-group>
                    </div>
                  </el-col>
                </el-row>
                
                <el-divider></el-divider>
                
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="挂号类型" prop="registrationType">
                      <el-select v-model="registrationForm.registrationType" placeholder="请选择" style="width: 100%" @change="calculateFee">
                        <el-option label="初诊" value="first"></el-option>
                        <el-option label="复诊" value="revisit"></el-option>
                        <el-option label="复查" value="recheck"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="挂号费用">
                      <el-input v-model="registrationForm.fee" disabled>
                        <template slot="append">元</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="就诊事由">
                      <el-input v-model="registrationForm.reason" placeholder="请简要描述就诊原因"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="支付方式" prop="paymentMethod">
                      <el-select v-model="registrationForm.paymentMethod" placeholder="请选择" style="width: 100%">
                        <el-option label="现金" value="cash"></el-option>
                        <el-option label="医保卡" value="insurance"></el-option>
                        <el-option label="微信支付" value="wechat"></el-option>
                        <el-option label="支付宝" value="alipay"></el-option>
                        <el-option label="银行卡" value="card"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                
                <div class="form-actions right">
                  <el-button type="success" @click="submitRegistration" :disabled="!patientConfirmed" icon="el-icon-finished">提交挂号</el-button>
                  <el-button type="primary" @click="printPreview" :disabled="!patientConfirmed" icon="el-icon-printer">打印预览</el-button>
                  <el-button @click="resetRegistrationForm" icon="el-icon-refresh">重置</el-button>
                </div>
              </el-form>
            </div>
          </el-card>
          
          <!-- 近期挂号记录 -->
          <el-card shadow="hover" class="records-card">
            <div slot="header">
              <div class="card-header">
                <span><i class="el-icon-tickets"></i> 近期挂号记录</span>
                <el-button type="text" @click="handleMore">更多记录</el-button>
              </div>
            </div>
            
            <el-table :data="registrationRecords" stripe style="width: 100%" size="small" height="280">
              <el-table-column prop="registerNo" label="挂号单号" width="110"></el-table-column>
              <el-table-column prop="patientName" label="患者姓名" width="90"></el-table-column>
              <el-table-column prop="departmentName" label="科室" width="100"></el-table-column>
              <el-table-column prop="doctorName" label="医生" width="90"></el-table-column>
              <el-table-column prop="registerDate" label="就诊日期" width="100"></el-table-column>
              <el-table-column prop="timeSlot" label="就诊时间" width="90"></el-table-column>
              <el-table-column prop="status" label="状态" width="90">
                <template slot-scope="scope">
                  <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="printTicket(scope.row)">打印</el-button>
                  <el-button type="text" size="small" @click="cancelRegistration(scope.row)" 
                             :disabled="scope.row.status === 'completed' || scope.row.status === 'cancelled'">取消</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 打印预览对话框 -->
      <el-dialog
        title="挂号单预览"
        :visible.sync="printDialogVisible"
        width="400px"
        center>
        <div class="print-preview">
          <div class="print-header">
            <h3>北京协和医院门诊挂号单</h3>
            <p>挂号单号：{{ printInfo.registerNo }}</p>
          </div>
          <div class="print-content">
            <div class="print-item">
              <span class="print-label">患者姓名：</span>
              <span>{{ printInfo.patientName }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">性别/年龄：</span>
              <span>{{ printInfo.gender }}/{{ printInfo.age }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">就诊卡号：</span>
              <span>{{ printInfo.cardNo }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">科室：</span>
              <span>{{ printInfo.departmentName }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">医生：</span>
              <span>{{ printInfo.doctorName }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">就诊日期：</span>
              <span>{{ printInfo.registerDate }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">就诊时间：</span>
              <span>{{ printInfo.timeSlot }}</span>
            </div>
            <div class="print-item">
              <span class="print-label">挂号费用：</span>
              <span>{{ printInfo.fee }}元</span>
            </div>
            <div class="print-item">
              <span class="print-label">支付方式：</span>
              <span>{{ getPaymentMethodText(printInfo.paymentMethod) }}</span>
            </div>
          </div>
          <div class="print-footer">
            <p>请在就诊时间前15分钟到达候诊区候诊</p>
            <p>如需取消挂号，请提前2小时操作</p>
            <p>打印时间：{{ printInfo.printTime }}</p>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="printDialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="doPrint">打印</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  export default {
    name: 'AppointmentManagement',
    data() {
      return {
        currentTime: this.formatDateTime(new Date()),
        searchKey: '',
        patientConfirmed: false,
        // 患者表单
        patientForm: {
          name: '',
          idCard: '',
          phone: '',
          gender: '男',
          age: 30,
          cardNo: '',
          insuranceType: 'self',
          remark: ''
        },
        // 挂号表单
        registrationForm: {
          registerDate: new Date(),
          visitType: 'normal',
          department: [],
          doctor: '',
          timeSlot: '',
          registrationType: 'first',
          fee: '0',
          reason: '',
          paymentMethod: 'cash'
        },
        // 校验规则
        patientRules: {
          name: [{ required: true, message: '请输入患者姓名', trigger: 'blur' }],
          idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
        },
        registrationRules: {
          registerDate: [{ required: true, message: '请选择挂号日期', trigger: 'change' }],
          visitType: [{ required: true, message: '请选择就诊类型', trigger: 'change' }],
          department: [{ required: true, message: '请选择科室', trigger: 'change' }],
          doctor: [{ required: true, message: '请选择医生', trigger: 'change' }],
          timeSlot: [{ required: true, message: '请选择就诊时段', trigger: 'change' }],
          registrationType: [{ required: true, message: '请选择挂号类型', trigger: 'change' }],
          paymentMethod: [{ required: true, message: '请选择支付方式', trigger: 'change' }]
        },
        // 日期选择器配置
        datePickerOptions: {
          disabledDate(date) {
            // 禁用今天之前的日期和15天后的日期
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + 15);
            return date < today || date > maxDate;
          }
        },
        // 科室数据
        departmentOptions: [
          {
            value: 'internal',
            label: '内科',
            children: [
              { value: 'cardio', label: '心内科' },
              { value: 'resp', label: '呼吸内科' },
              { value: 'gastro', label: '消化内科' },
              { value: 'endo', label: '内分泌科' },
              { value: 'nephro', label: '肾内科' },
              { value: 'neuro', label: '神经内科' },
              { value: 'hemato', label: '血液内科' },
              { value: 'rheuma', label: '风湿免疫科' }
            ]
          },
          {
            value: 'surgical',
            label: '外科',
            children: [
              { value: 'general', label: '普通外科' },
              { value: 'ortho', label: '骨科' },
              { value: 'neuro_surgery', label: '神经外科' },
              { value: 'cardiac_surgery', label: '心胸外科' },
              { value: 'plastic', label: '整形外科' },
              { value: 'burn', label: '烧伤科' },
              { value: 'urology', label: '泌尿外科' }
            ]
          },
          {
            value: 'gynecology',
            label: '妇产科',
            children: [
              { value: 'obs', label: '产科' },
              { value: 'gyn', label: '妇科' },
              { value: 'repro', label: '生殖医学科' }
            ]
          },
          {
            value: 'pediatrics',
            label: '儿科',
            children: [
              { value: 'ped_general', label: '小儿内科' },
              { value: 'ped_surgery', label: '小儿外科' },
              { value: 'neonatology', label: '新生儿科' }
            ]
          },
          {
            value: 'others',
            label: '其他科室',
            children: [
              { value: 'ophth', label: '眼科' },
              { value: 'ent', label: '耳鼻喉科' },
              { value: 'derm', label: '皮肤科' },
              { value: 'psych', label: '精神科' },
              { value: 'tcm', label: '中医科' },
              { value: 'dental', label: '口腔科' },
              { value: 'rehab', label: '康复科' },
              { value: 'oncology', label: '肿瘤科' }
            ]
          }
        ],
        // 可用医生列表
        availableDoctors: [],
        // 可用时段
        availableTimeSlots: [],
        // 挂号记录
        registrationRecords: [],
        // 打印对话框
        printDialogVisible: false,
        // 打印信息
        printInfo: {}
      }
    },
    created() {
      this.initDoctorData();
      this.initRegistrationRecords();
      this.updateTime();
    },
    methods: {
      // 更新时间
      updateTime() {
        setInterval(() => {
          this.currentTime = this.formatDateTime(new Date());
        }, 1000);
      },
      
      // 格式化日期时间
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      
      // 格式化日期
      formatDate(date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      
      // 新患者
      newPatient() {
        this.resetPatientForm();
        this.patientConfirmed = false;
      },
      
      // 搜索患者
      searchPatient() {
        if (!this.searchKey) {
          this.$message.warning('请输入搜索关键词');
          return;
        }
        
        // 模拟搜索延迟
        this.$message({
          type: 'info',
          message: '正在查询患者信息...'
        });
        
        setTimeout(() => {
          // 模拟搜索结果
          if (this.searchKey.includes('许') || this.searchKey.includes('123')) {
            this.patientForm = {
              name: '许昊然',
              idCard: '110101199001010123',
              phone: '13800138000',
              gender: '男',
              age: 33,
              cardNo: 'P100001',
              insuranceType: 'employee',
              remark: '高血压患者，长期服用降压药'
            };
            
            this.$message({
              type: 'success',
              message: '已找到患者信息'
            });
          } else if (this.searchKey.includes('李') || this.searchKey.includes('456')) {
            this.patientForm = {
              name: '苏雅婷',
              idCard: '110101199203020456',
              phone: '13900139000',
              gender: '女',
              age: 30,
              cardNo: 'P100002',
              insuranceType: 'resident',
              remark: ''
            };
            
            this.$message({
              type: 'success',
              message: '已找到患者信息'
            });
          } else {
            this.$message({
              type: 'warning',
              message: '未找到匹配的患者，请重新搜索或录入新患者信息'
            });
          }
        }, 800);
      },
      
      // 生成就诊卡号
      generateCardNo() {
        const prefix = 'P';
        const randomNum = Math.floor(100000 + Math.random() * 900000);
        this.patientForm.cardNo = prefix + randomNum;
        
        this.$message({
          type: 'success',
          message: '已自动生成就诊卡号'
        });
      },
      
      // 确认患者信息
      confirmPatient() {
        this.$refs.patientForm.validate(valid => {
          if (valid) {
            this.patientConfirmed = true;
            this.$message({
              type: 'success',
              message: `已确认患者信息: ${this.patientForm.name}`
            });
          } else {
            return false;
          }
        });
      },
      
      // 重置患者表单
      resetPatientForm() {
        if (this.$refs.patientForm) {
          this.$refs.patientForm.resetFields();
        }
        
        this.patientForm = {
          name: '',
          idCard: '',
          phone: '',
          gender: '男',
          age: 30,
          cardNo: '',
          insuranceType: 'self',
          remark: ''
        };
        
        this.patientConfirmed = false;
      },
      
      // 初始化医生数据
      initDoctorData() {
        // 这里简化，实际应该根据科室和日期动态加载医生
        this.doctorDatabase = {
          'internal-cardio': [
            { id: 'doc1', name: '陈医生', title: '主任医师', availableDays: [1, 2, 3, 4, 5] },
            { id: 'doc2', name: '王医生', title: '副主任医师', availableDays: [1, 3, 5] },
            { id: 'doc3', name: '李医生', title: '主治医师', availableDays: [2, 4] }
          ],
          'internal-resp': [
            { id: 'doc4', name: '赵医生', title: '主任医师', availableDays: [2, 4] },
            { id: 'doc5', name: '钱医生', title: '主治医师', availableDays: [1, 3, 5] }
          ],
          'surgical-ortho': [
            { id: 'doc6', name: '孙医生', title: '主任医师', availableDays: [1, 2, 5] },
            { id: 'doc7', name: '周医生', title: '副主任医师', availableDays: [3, 4] }
          ],
          'ophth': [
            { id: 'doc8', name: '吴医生', title: '主任医师', availableDays: [1, 3, 5] },
            { id: 'doc9', name: '郑医生', title: '主治医师', availableDays: [2, 4] }
          ]
        };
        
        // 时段模板
        this.timeSlotTemplates = [
          { id: 'am1', time: '08:00-08:30', capacity: 5 },
          { id: 'am2', time: '08:30-09:00', capacity: 5 },
          { id: 'am3', time: '09:00-09:30', capacity: 5 },
          { id: 'am4', time: '09:30-10:00', capacity: 5 },
          { id: 'am5', time: '10:00-10:30', capacity: 5 },
          { id: 'am6', time: '10:30-11:00', capacity: 5 },
          { id: 'pm1', time: '13:30-14:00', capacity: 5 },
          { id: 'pm2', time: '14:00-14:30', capacity: 5 },
          { id: 'pm3', time: '14:30-15:00', capacity: 5 },
          { id: 'pm4', time: '15:00-15:30', capacity: 5 },
          { id: 'pm5', time: '15:30-16:00', capacity: 5 },
          { id: 'pm6', time: '16:00-16:30', capacity: 5 }
        ];
      },
      
      // 日期变化处理
      handleDateChange(date) {
        // 重置医生和时段
        this.registrationForm.doctor = '';
        this.registrationForm.timeSlot = '';
        this.availableTimeSlots = [];
        
        // 如果已经选择了科室，重新加载可用医生
        if (this.registrationForm.department && this.registrationForm.department.length === 2) {
          this.handleDepartmentChange(this.registrationForm.department);
        }
      },
      
      // 科室选择变化处理
      handleDepartmentChange(value) {
        this.registrationForm.doctor = '';
        this.registrationForm.timeSlot = '';
        this.availableTimeSlots = [];
        
        if (!value || value.length < 2) return;
        
        const deptKey = value.length === 2 
          ? `${value[0]}-${value[1]}` 
          : value[1];
        
        // 找出今天是星期几
        const date = this.registrationForm.registerDate || new Date();
        const day = date.getDay() || 7; // 0是周日，转换为1-7
        
        // 根据科室和日期筛选可用医生
        this.availableDoctors = (this.doctorDatabase[deptKey] || [])
          .filter(doctor => doctor.availableDays.includes(day))
          .map(doctor => ({ ...doctor }));
        
        if (this.availableDoctors.length === 0) {
          this.$message.warning('当前日期该科室没有可预约医生，请选择其他日期或科室');
        }
      },
      
      // 医生选择变化处理
      handleDoctorChange(doctorId) {
        this.registrationForm.timeSlot = '';
        
        if (!doctorId) {
          this.availableTimeSlots = [];
          return;
        }
        
        // 模拟加载该医生的可用时段
        setTimeout(() => {
          // 随机生成每个时段的剩余号数
          this.availableTimeSlots = this.timeSlotTemplates.map(slot => {
            const remaining = Math.floor(Math.random() * (slot.capacity + 1)); // 0 到 capacity
            return {
              ...slot,
              remaining
            };
          });
        }, 300);
      },
      
      // 计算挂号费用
      calculateFee() {
        // 根据就诊类型和挂号类型计算费用
        let baseFee = 0;
        
        switch (this.registrationForm.visitType) {
          case 'normal':
            baseFee = 20;
            break;
          case 'expert':
            baseFee = 50;
            break;
          case 'special':
            baseFee = 100;
            break;
          case 'emergency':
            baseFee = 80;
            break;
          default:
            baseFee = 20;
        }
        
        // 复诊折扣
        if (this.registrationForm.registrationType === 'revisit') {
          baseFee = Math.round(baseFee * 0.8);
        } else if (this.registrationForm.registrationType === 'recheck') {
          baseFee = Math.round(baseFee * 0.5);
        }
        
        this.registrationForm.fee = baseFee.toString();
      },
      
      // 重置挂号表单
      resetRegistrationForm() {
        if (this.$refs.registrationForm) {
          this.$refs.registrationForm.resetFields();
        }
        
        this.registrationForm = {
          registerDate: new Date(),
          visitType: 'normal',
          department: [],
          doctor: '',
          timeSlot: '',
          registrationType: 'first',
          fee: '0',
          reason: '',
          paymentMethod: 'cash'
        };
        
        this.availableDoctors = [];
        this.availableTimeSlots = [];
      },
      
      // 生成挂号号码
      generateRegisterNo() {
        const date = new Date();
        const year = date.getFullYear().toString().substr(2);
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const random = Math.floor(1000 + Math.random() * 9000);
        return `R${year}${month}${day}${random}`;
      },
      
      // 提交挂号
      submitRegistration() {
        this.$refs.registrationForm.validate(valid => {
          if (valid) {
            // 获取选中的时段
            const selectedTimeSlot = this.availableTimeSlots.find(
              slot => slot.id === this.registrationForm.timeSlot
            );
            
            if (!selectedTimeSlot) {
              this.$message.error('请选择有效的就诊时段');
              return false;
            }
            
            // 获取科室和医生名称
            let departmentName = '';
            if (this.registrationForm.department && this.registrationForm.department.length >= 2) {
              const deptGroup = this.departmentOptions.find(
                item => item.value === this.registrationForm.department[0]
              );
              if (deptGroup) {
                const dept = deptGroup.children.find(
                  item => item.value === this.registrationForm.department[1]
                );
                if (dept) {
                  departmentName = dept.label;
                }
              }
            }
            
            const selectedDoctor = this.availableDoctors.find(
              doc => doc.id === this.registrationForm.doctor
            );
            const doctorName = selectedDoctor ? selectedDoctor.name : '';
            
            // 创建挂号记录
            const registerNo = this.generateRegisterNo();
            const registerDate = this.formatDate(this.registrationForm.registerDate);
            
            const newRegistration = {
              registerNo,
              patientName: this.patientForm.name,
              patientGender: this.patientForm.gender,
              patientAge: this.patientForm.age,
              cardNo: this.patientForm.cardNo,
              departmentName,
              doctorName,
              registerDate,
              timeSlot: selectedTimeSlot.time,
              fee: this.registrationForm.fee,
              paymentMethod: this.registrationForm.paymentMethod,
              status: 'waiting', // 待就诊
              createTime: this.formatDateTime(new Date())
            };
            
            // 添加到记录中
            this.registrationRecords.unshift(newRegistration);
            
            // 准备打印数据
            this.printInfo = {
              registerNo,
              patientName: this.patientForm.name,
              gender: this.patientForm.gender,
              age: this.patientForm.age,
              cardNo: this.patientForm.cardNo,
              departmentName,
              doctorName,
              registerDate,
              timeSlot: selectedTimeSlot.time,
              fee: this.registrationForm.fee,
              paymentMethod: this.registrationForm.paymentMethod,
              printTime: this.formatDateTime(new Date())
            };
            
            // 显示打印预览
            this.printDialogVisible = true;
            
            // 成功提示
            this.$message({
              type: 'success',
              message: '挂号成功'
            });
            
            // 重置挂号表单
            this.resetRegistrationForm();
          } else {
            return false;
          }
        });
      },
      
      // 打印预览
      printPreview() {
        this.$refs.registrationForm.validate(valid => {
          if (valid) {
            // 生成打印信息，与提交挂号类似，但不添加记录
            const selectedTimeSlot = this.availableTimeSlots.find(
              slot => slot.id === this.registrationForm.timeSlot
            );
            
            if (!selectedTimeSlot) {
              this.$message.error('请选择有效的就诊时段');
              return false;
            }
            
            let departmentName = '';
            if (this.registrationForm.department && this.registrationForm.department.length >= 2) {
              const deptGroup = this.departmentOptions.find(
                item => item.value === this.registrationForm.department[0]
              );
              if (deptGroup) {
                const dept = deptGroup.children.find(
                  item => item.value === this.registrationForm.department[1]
                );
                if (dept) {
                  departmentName = dept.label;
                }
              }
            }
            
            const selectedDoctor = this.availableDoctors.find(
              doc => doc.id === this.registrationForm.doctor
            );
            const doctorName = selectedDoctor ? selectedDoctor.name : '';
            
            // 准备打印数据
            this.printInfo = {
              registerNo: this.generateRegisterNo(),
              patientName: this.patientForm.name,
              gender: this.patientForm.gender,
              age: this.patientForm.age,
              cardNo: this.patientForm.cardNo,
              departmentName,
              doctorName,
              registerDate: this.formatDate(this.registrationForm.registerDate),
              timeSlot: selectedTimeSlot.time,
              fee: this.registrationForm.fee,
              paymentMethod: this.registrationForm.paymentMethod,
              printTime: this.formatDateTime(new Date())
            };
            
            // 显示打印预览
            this.printDialogVisible = true;
          } else {
            return false;
          }
        });
      },
      
      // 实际打印
      doPrint() {
        this.$message({
          type: 'success',
          message: '正在打印挂号单...'
        });
        
        setTimeout(() => {
          this.printDialogVisible = false;
        }, 1000);
      },
      
      // 打印已有挂号单
      printTicket(row) {
        this.printInfo = {
          registerNo: row.registerNo,
          patientName: row.patientName,
          gender: row.patientGender,
          age: row.patientAge,
          cardNo: row.cardNo,
          departmentName: row.departmentName,
          doctorName: row.doctorName,
          registerDate: row.registerDate,
          timeSlot: row.timeSlot,
          fee: row.fee,
          paymentMethod: row.paymentMethod,
          printTime: this.formatDateTime(new Date())
        };
        
        this.printDialogVisible = true;
      },
      
      // 取消挂号
      cancelRegistration(row) {
        this.$confirm('确定要取消此挂号吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const index = this.registrationRecords.findIndex(item => item.registerNo === row.registerNo);
          if (index !== -1) {
            this.registrationRecords[index].status = 'cancelled';
            this.$message({
              type: 'success',
              message: '挂号已取消'
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      
      // 查看更多记录
      handleMore() {
        this.$message({
          type: 'info',
          message: '查看所有挂号记录（功能待开发）'
        });
      },
      
      // 获取支付方式文本
      getPaymentMethodText(method) {
        const methodMap = {
          cash: '现金',
          insurance: '医保卡',
          wechat: '微信支付',
          alipay: '支付宝',
          card: '银行卡'
        };
        return methodMap[method] || method;
      },
      
      // 获取状态文本
      getStatusText(status) {
        const statusMap = {
          waiting: '待就诊',
          processing: '就诊中',
          completed: '已完成',
          cancelled: '已取消'
        };
        return statusMap[status] || status;
      },
      
      // 获取状态标签类型
      getStatusType(status) {
        const typeMap = {
          waiting: 'info',
          processing: 'warning',
          completed: 'success',
          cancelled: 'danger'
        };
        return typeMap[status] || '';
      },
      
      // 初始化挂号记录
      initRegistrationRecords() {
        // 模拟一些历史挂号记录
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        
        const todayStr = this.formatDate(today);
        const yesterdayStr = this.formatDate(yesterday);
        
        this.registrationRecords = [
          {
            registerNo: 'R2504090001',
            patientName: '许昊然',
            patientGender: '男',
            patientAge: 33,
            cardNo: 'P100001',
            departmentName: '心内科',
            doctorName: '陈医生',
            registerDate: todayStr,
            timeSlot: '09:00-09:30',
            fee: '50',
            paymentMethod: 'insurance',
            status: 'waiting',
            createTime: `${todayStr} 08:15:30`
          },
          {
            registerNo: 'R2504090002',
            patientName: '苏雅婷',
            patientGender: '女',
            patientAge: 30,
            cardNo: 'P100002',
            departmentName: '皮肤科',
            doctorName: '王医生',
            registerDate: todayStr,
            timeSlot: '10:30-11:00',
            fee: '20',
            paymentMethod: 'wechat',
            status: 'processing',
            createTime: `${todayStr} 09:20:45`
          },
          {
            registerNo: 'R2504080012',
            patientName: '林书辰',
            patientGender: '男',
            patientAge: 45,
            cardNo: 'P100003',
            departmentName: '骨科',
            doctorName: '孙医生',
            registerDate: yesterdayStr,
            timeSlot: '14:00-14:30',
            fee: '20',
            paymentMethod: 'cash',
            status: 'completed',
            createTime: `${yesterdayStr} 10:05:12`
          },
          {
            registerNo: 'R2504080008',
            patientName: '程若曦',
            patientGender: '女',
            patientAge: 28,
            cardNo: 'P100004',
            departmentName: '眼科',
            doctorName: '吴医生',
            registerDate: yesterdayStr,
            timeSlot: '09:30-10:00',
            fee: '20',
            paymentMethod: 'alipay',
            status: 'cancelled',
            createTime: `${yesterdayStr} 08:30:20`
          }
        ];
      }
    }
  }
  </script>
  
  <style scoped>
  .registration-service {
    padding: 15px;
    min-height: calc(100vh - 100px);
    background-color: #f5f7fa;
  }
  
  .header-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  
  .title-container h2 {
    margin: 0;
    font-size: 20px;
    color: #303133;
  }
  
  .operator-info {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  
  .operator-info span {
    margin-right: 15px;
    color: #606266;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .patient-card,
  .registration-card,
  .records-card {
    margin-bottom: 20px;
  }
  
  .patient-form {
    margin-top: 15px;
  }
  
  .search-area {
    margin-bottom: 15px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .form-actions {
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
  
  .form-actions.right {
    justify-content: flex-end;
  }
  
  .registration-area.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
  
  .schedule-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .schedule-title h4 {
    margin: 0;
    font-size: 16px;
    color: #303133;
  }
  
  .time-slots {
    margin-bottom: 20px;
  }
  
  .time-slots .el-radio-button {
    margin-right: 10px;
    margin-bottom: 10px;
  }
  
  .time-slots .el-radio-button:last-child {
    margin-right: 0;
  }
  
  .print-preview {
    background-color: white;
    border: 1px solid #dcdfe6;
    padding: 20px;
    font-size: 14px;
  }
  
  .print-header {
    text-align: center;
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 10px;
    margin-bottom: 15px;
  }
  
  .print-header h3 {
    font-size: 18px;
    margin-top: 0;
    margin-bottom: 10px;
  }
  
  .print-header p {
    margin: 5px 0;
    font-size: 14px;
  }
  
  .print-content {
    margin-bottom: 15px;
  }
  
  .print-item {
    display: flex;
    margin-bottom: 8px;
  }
  
  .print-label {
    width: 90px;
    font-weight: bold;
    color: #606266;
  }
  
  .print-footer {
    border-top: 1px solid #dcdfe6;
    padding-top: 10px;
    color: #909399;
    font-size: 12px;
  }
  
  .print-footer p {
    margin: 5px 0;
  }
  
  /* 响应式布局 */
  @media (max-width: 1200px) {
    .patient-form .el-form-item {
      margin-bottom: 18px;
    }
    
    .time-slots .el-radio-button {
      margin-bottom: 8px;
    }
  }
  
  @media (max-width: 768px) {
    .header-info {
      flex-direction: column;
      align-items: flex-start;
    }
    
    .operator-info {
      margin-top: 10px;
    }
  }
  </style>